export class InvalidArgumentType extends Error {}
